import React from 'react';
import { Link } from 'react-router-dom';
import CatalogBreadcrumb from '../CatalogBreadcrumb';
import ChevronIcon from './icons/ChevronIcon';
import { formatDisplayTitle } from '../formatProductTitle';

/**
 * Compact hero for sub-group product lists (e.g. Single Rakhi, Kids Rakhi).
 */
export default function CollectionSubheader({
  breadcrumbs = [],
  backTo,
  backLabel = 'Back',
  title,
  tagline = '',
  count,
  countLabel,
  className = '',
}) {
  const countText =
    count != null && count >= 0
      ? `${count} ${countLabel || (count === 1 ? 'design' : 'designs')}`
      : '';

  return (
    <header className={`collection-subheader collection-subheader--editorial ${className}`.trim()}>
      {backTo ? (
        <Link to={backTo} className="collection-subheader__back">
          <ChevronIcon direction="left" />
          <span>{backLabel}</span>
        </Link>
      ) : null}
      {breadcrumbs.length > 0 ? (
        <CatalogBreadcrumb
          items={breadcrumbs}
          align="start"
          className="collection-subheader__crumb catalog-breadcrumb--refined"
        />
      ) : null}
      <div className="collection-subheader__body">
        <div className="collection-subheader__title-row">
          <h1 className="collection-subheader__title">{formatDisplayTitle(title)}</h1>
          {countText ? <span className="collection-subheader__count">{countText}</span> : null}
        </div>
        {tagline ? <p className="collection-subheader__tagline">{tagline}</p> : null}
      </div>
    </header>
  );
}
